module.exports = __webpack_public_path__ + "img/DreaMagicLogoB.d47afac5.png";